import { render, staticRenderFns } from "./modal-edit-tags.vue?vue&type=template&id=42421f74&"
import script from "./modal-edit-tags.vue?vue&type=script&lang=js&"
export * from "./modal-edit-tags.vue?vue&type=script&lang=js&"
import style0 from "./modal-edit-tags.vue?vue&type=style&index=0&id=42421f74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports